const getFormattedAmount = (amount: number) =>
  new Intl.NumberFormat("en-US", {
    currency: "USD",
    style: "currency",
  }).format(amount ? amount / 100 : 0);

export default getFormattedAmount;
